import React, { PureComponent, ReactNode } from 'react';
import classNames from 'classnames/bind';

import { IProps } from './types/sidebar';
import style from './sidebar.pcss';

class Sidebar extends PureComponent<IProps> {

    cn = classNames.bind(style);

    render(): ReactNode {
        return <div className={this.cn('sidebar', this.props.className)}>{this.props.children}</div>;
    }

}

export default Sidebar;
